<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Nueva Localidad">
          <b-form>
            <b-form-group
              label="Provincia"
              label-for="provincia"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="provincia"
                :value="provinciaNombre" 
                type="text"
                readonly>>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate"
                @keyup.enter.native="save">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
            
            <div slot="footer">
              <b-button size="sm" variant="primary" class="footer-button"
                @click.prevent="save">Grabar</b-button>
              <b-button size="sm" variant="danger" class="footer-button"
                @click.prevent="goBack">Volver</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'localidad/getField',
  mutationType: 'localidad/updateField',
});

export default {
  name: 'ABM',
  components: {
  },
  props: {
    provincia: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      procesando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
    ]),
    provinciaNombre: function() {
      return this.provincia.nombre.trim();
    }
  },  
  created() {
    let provinciaId = 0;
    if (this.provincia) {
      provinciaId = this.provincia.id;
    }

    this.$store.dispatch('localidad/inicializar', 0);
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'El nombre es un campo obligatorio.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$store.dispatch('localidad/setProvincia', this.provincia);

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.procesando = Boolean(true);
        this.$store.dispatch('localidad/save')
          .then(()  => {
            this.procesando = Boolean(true);
            this.$emit('updateLocalidades', this.nombre.toUpperCase().trim());
          })
          .catch( error => {
            this.procesando = Boolean(false);
            alert(error.errorMessage);
            /*
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = error.errorMessage;
            this.modalMsj = true;
            */
          });
          /*
          .finally( () => {
            this.procesando = Boolean(true);
          });
          */
      }
    },
    goBack() {
      this.$emit('closeLocalidad');
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
